import React from "react";
import { money } from "../ui/wholesaleCart";
import "./SyncReport.css";

// What a Resynchronize actually brought in (server report), in the Seller's language -- the same
// facts Add/Buy already rely on (elakayFees/commercialPricing). Extracted from
// SellerProviderProducts.jsx so both the linked-products list and ResyncModal's Automatic step
// render the exact same summary instead of two copies.
const WARNING_KEY = { NO_FILTERS_SELECTED: "warnNoFilters", PROVIDER_HAS_NO_FILTERS: "warnProviderNoFilters", PROVIDER_PRODUCT_UNAVAILABLE: "warnUnavailable", DROPSHIPPING_DISABLED: "warnDsDisabled", SELLING_PRICE_BELOW_COST: "dsi_warnBelowCost" };

export default function SyncReport({ report, ct }) {
  if (!report) return null;
  return (
    <div className="sync-report" data-testid="sync-report">
      <strong>{ct("reportTitle")}</strong>
      <ul>
        <li>{ct("repImages").replace("{value0}", report.images.count)}</li>
        <li>{ct("repCategories").replace("{value0}", report.categories)}</li>
        <li>{ct("repFilters").replace("{value0}", report.filters.selected)} · {ct("repVariants").replace("{value0}", report.variants)}</li>
        <li>
          {report.cost.changed
            ? ct("repCostChanged").replace("{value0}", money(report.cost.previous)).replace("{value1}", money(report.cost.current))
            : ct("repCostSame").replace("{value0}", money(report.cost.current))}
        </li>
        <li>{ct(report.availability.source === "seller_purchased_stock" ? "repAvailOwn" : "repAvailProvider").replace("{value0}", report.availability.units)}</li>
        {report.cost.changed && <li>{ct("repPurchasedKept")}</li>}
      </ul>
      {report.warnings.map((w) => <p key={w} className="sync-report__banner" role="alert">{ct(WARNING_KEY[w] || "warnUnavailable")}</p>)}
    </div>
  );
}
